import { SelectedTasksStore } from '@bringg-frontend/monitoring-shared';

import { generateStoreHelpers } from 'bringg-web/components/with-root-store/store-helper-generator';
import OrderExplorerStore from './order-explorer-store';
import OrdersMapStore from './orders-map-store';

class OrderExplorerRootStore {
	private static _instance?: OrderExplorerRootStore;

	private disposeAC: AbortController;

	orderExplorerStore: OrderExplorerStore;

	selectedTasksStore: SelectedTasksStore;

	ordersMapStore: OrdersMapStore;

	public static get instance(): OrderExplorerRootStore {
		if (!OrderExplorerRootStore._instance) {
			OrderExplorerRootStore._instance = new OrderExplorerRootStore();
			OrderExplorerRootStore._instance.init();
		}

		return OrderExplorerRootStore._instance;
	}

	init() {
		this.disposeAC = new AbortController();
		this.orderExplorerStore = new OrderExplorerStore(this.disposeAC.signal);
		this.selectedTasksStore = new SelectedTasksStore();
		this.ordersMapStore = new OrdersMapStore();
	}

	static clear() {
		if (OrderExplorerRootStore._instance) {
			OrderExplorerRootStore._instance.disposeAC.abort();
			OrderExplorerRootStore._instance = undefined;
		}
	}
}

export type OrderExplorerRoot = OrderExplorerRootStore;

export const orderExplorerRootStore = {
	getStore: () => OrderExplorerRootStore.instance,
	clearStore: () => OrderExplorerRootStore.clear()
};

export const { useStoreContext: useOrderExplorerRootStore, withRootStore: withOrderExplorerRootStore } =
	generateStoreHelpers(orderExplorerRootStore);
